import { css } from "@emotion/react"
import { ButtonGroup, FormLayout, FormLayoutGroup, Skeleton } from "src/components"

export const NewsEditorFormSkeleton = () => (
	<>
		<FormLayoutGroup>
			<FormLayout>
				<Skeleton.Input withLabel withDescription />
			</FormLayout>
			<FormLayout>
				<Skeleton.Textarea withLabel withDescription />
			</FormLayout>
			<FormLayout>
				<Skeleton.Input withLabel />
			</FormLayout>
			<FormLayout>
				<Skeleton.Input withLabel />
			</FormLayout>
			<FormLayout>
				<Skeleton.Input withLabel withDescription />
			</FormLayout>
		</FormLayoutGroup>
		<ButtonGroup>
			<Skeleton.Input inputCssRuleSet={buttonStyles} />
			<Skeleton.Input inputCssRuleSet={buttonStyles} />
		</ButtonGroup>
	</>
)

const buttonStyles = css`
	width: 100px;
`
